import {
  DesignTokenSizeEnum,
  Text,
  TokenTextAppearance,
  TextTag,
  styled,
} from '@volkswagen-onehub/components-core';
import { useTribalContext } from '@/context/tribal';
import { CTAMail, SectionHeader, Box } from '@/modules/components';
import useGlobalStore from '@/stores/globalStore';
import { getNewCarsDepartment } from '@/modules/utils/storeUtils';
import { ButtonWrapper } from '@/styles';
import { performVWBasicButtonClick } from '@/analytics/events';
import { SectionNames } from '@/analytics/sectionNames';

const StyledHeader = styled.div(
  ({ theme }) => `
  display: flex;
  width: 100vw;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  background-blend-mode: multiply;
  background: linear-gradient(0deg, #F0EEE9 -0.9%, rgba(240, 238, 233, 0) 82.93%);

  padding:${theme.size.dynamic0300} ${theme.size.dynamic0200};
`
);

const CompareHero = () => {
  const { contentManager, analyticsManager, analyticsBuilder } =
    useTribalContext();
  const { configurations, retailers } = useGlobalStore((state) => state.app);
  const retailerEmail = getNewCarsDepartment(
    retailers[0]?.departments || []
  )?.contactEmail;

  const contactRetailerCtaLabel = contentManager.get('ctas-contact-retailer');

  return (
    <StyledHeader>
      <Box mb={DesignTokenSizeEnum.dynamic0050}>
        <SectionHeader
          title={contentManager.get('compare-hero-title-normal')}
          titleBold={contentManager.get('compare-hero-title-bold')}
          titleSize={TokenTextAppearance.headline400}
        />
      </Box>
      <Box
        as={Text}
        appearance={TokenTextAppearance.headline200}
        mb={DesignTokenSizeEnum.static350}
        tag={TextTag.h3}
        maxWidth="800px"
      >
        {contentManager.get('compare-hero-subtitle-1')}
      </Box>
      <Box
        as={Text}
        appearance={TokenTextAppearance.headline200}
        tag={TextTag.h3}
        mb={DesignTokenSizeEnum.dynamic0130}
      >
        {contentManager.get('compare-hero-subtitle-2')}
      </Box>
      {retailerEmail && (
        <ButtonWrapper>
          <CTAMail
            mailto={retailerEmail}
            onClick={() => {
              performVWBasicButtonClick({
                label: contactRetailerCtaLabel,
                sectionName: SectionNames.COMPARE_PAGE_HEADER,
                configurations,
                retailers,
                analyticsManager,
                analyticsBuilder,
              });
            }}
          >
            {contactRetailerCtaLabel}
          </CTAMail>
        </ButtonWrapper>
      )}
    </StyledHeader>
  );
};

export default CompareHero;
